import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive()
export class RxjsDirective implements OnDestroy {
  subs: Subscription[] = [];

  register(...sub: Subscription[]) {
    this.subs = this.subs.concat(sub);
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
